import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components';

import BaseElement from './BaseElement';
import { noop } from 'utils';

export function renderPageBreakElement(params) {

   return (props) => {
      if (props.element.type === 'break') { 
        return (
            <PageBreakElement {...props} {...params} />
        );
      }
    
      return undefined;
   }

}



export const PageBreakPlugin = (params) => ({
  renderElement: renderPageBreakElement(params),
  voidTypes: ['break']
});

const StyledDiv = styled.div`
  font-size: 8pt;
  text-transform: uppercase;
  font-weight: bold;
  text-align: center;
`

export default function PageBreakElement({ attributes, element, children, ...props }) {
  const { t } = useTranslation();

  return (
    <BaseElement className="page-break" element={element} type="break" {...props} {...attributes}>
      {() => (
          <BaseElement.NoEditableField>
            <StyledDiv>
              {t('page-break')}
              {children}
            </StyledDiv>
          </BaseElement.NoEditableField>
      )}
    </BaseElement>
  )
}